/* Önerilen ürünleri Shopify'ın öneri motorundan çeker.
   Sunucu tarafında zaten bir liste basıldığı için bu yalnızca tazeleme:
   motor kişiselleştirilmiş sonuç döndürürse yerine koyar. */
(function () {
  'use strict';

  const section = document.querySelector('[data-recs]');
  if (!section || !section.dataset.url) return;

  fetch(section.dataset.url)
    .then(function (response) {
      if (!response.ok) throw new Error('recommendations failed');
      return response.text();
    })
    .then(function (html) {
      const fresh = window.KS.extract(html, '.ks-pgrid');
      const current = section.querySelector('.ks-pgrid');
      // Motor boş dönerse mevcut yedek listeyi bozmuyoruz.
      if (fresh && current && fresh.children.length > 0) {
        current.innerHTML = fresh.innerHTML;
      }
    })
    .catch(function () { /* yedek liste zaten basılı */ });
})();
